import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import trackGa from '../utils/trackEvent';

export const truncateString = (string, maxLength, separator = ' ') =>
	string.substr(0, string.lastIndexOf(separator, maxLength)) ||
	string.substr(0, maxLength);

export const ReviewContent = ({
	content,
	truncate,
	openModal,
	windowId,
	maxCharacters,
	seeFullReviewLabel,
	fontSize
}) => {
	const truncateContent = (text, maxLength) => {
		if (text.length <= maxLength) {
			return text;
		} else {
			const trucatedText = truncateString(text, maxLength);
			return (
				<React.Fragment>
					{`${trucatedText}... `}
					<button
						className="text-link"
						type="button"
						onClick={() => {
							openModal();
							trackGa(
								windowId,
								'Full review button',
								'Full review shown'
							);
						}}
					>
						{seeFullReviewLabel}
					</button>
				</React.Fragment>
			);
		}
	};

	const preserveLineBreaks = (string = '') => {
		const newLineRegex = /(?:\r?\n|\r)/;
		return string
			.trim()
			.split(newLineRegex)
			.reduce((prev, curr) => (
				<React.Fragment>
					{prev}
					<br />
					{curr}
				</React.Fragment>
			));
	};

	return (
		<p className={setClassNames(['dealer-review-content', fontSize])}>
			{truncate
				? truncateContent(content, maxCharacters)
				: preserveLineBreaks(content)}
		</p>
	);
};

ReviewContent.propTypes = {
	truncate: PropTypes.bool.isRequired,
	fontSize: PropTypes.string,
	content: PropTypes.string,
	openModal: PropTypes.func,
	windowId: PropTypes.string,
	maxCharacters: PropTypes.number,
	seeFullReviewLabel: PropTypes.string
};

ReviewContent.defaultProps = {
	fontSize: ''
};

ReviewContent.defaultProps = {
	openModal: () => '',
	windowId: '',
	content: '',
	maxCharacters: 1,
	seeFullReviewLabel: ''
};
